import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridBrandsComponent } from './grid-banners.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomBannerModule } from '../banner/banner.module';

@NgModule({
  declarations: [GridBrandsComponent],
  imports: [CommonModule, CustomBannerModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GridBrands: {
          component: GridBrandsComponent,
        },
      },
    }),
  ],
  exports: [GridBrandsComponent],
})
export class BannerListModule {}
